import React from "react";

const phrases = [
  "Digital Solutions",
  "Business Growth",
  "Supply & Trading",
  "Trusted Partnerships",
  "Global Network",
];

function MarqueeRow() {
  return (
    <div className="oriba-scroll-text scroll-left">
      {phrases.map((phrase, index) => (
        <span className="scroll-text-inner" key={index}>
          <span className="text">{phrase}</span>
          <span className="icon">
            <i className="far fa-star-of-life"></i>
          </span>
        </span>
      ))}
    </div>
  );
}

function Marquee() {
  return (
    <section className="animated-text-slide pb-120">
      <MarqueeRow />
      <MarqueeRow />
    </section>
  );
}

export default Marquee;
